// @flow
export default (palette: Object) => ({ // eslint-disable-line no-unused-vars
    fontFamily: '"Open Sans", sans-serif;',
    fontSize: 14,
});
